import apiClient from '../apiClient';
import { GET_USER_PROFILE_ONLY_BY_USER_ID_URL } from '../apiUrl';

const getUserProfileOnlyByIdApi = Id => {
  return apiClient.get(GET_USER_PROFILE_ONLY_BY_USER_ID_URL(Id));
};

export default getUserProfileOnlyByIdApi;
